import React from 'react';
import AzureLogo from 'components/Icons/sources/Azure';
import CSVLogo from 'components/Icons/sources/CSV';
import GoogleWorkspaceLogo from 'components/Icons/sources/GoogleWorkspaceLogo';
import WorkdayLogo from 'components/Icons/sources/Workday';
import DemoDataLogo from 'components/Icons/sources/DemoDataLogo';

import { SourceType } from 'types/Source';

const sourceData: { [sourceType in SourceType]?: any } = {
  [SourceType.CSV]: {
    type: SourceType.CSV,
    title: 'Upload a CSV',
    description:
      'Quickly and easily upload a CSV file from any external data source like an HR system, or create one using our CSV template. Optionally set up an SFTP integration to automate the process.',
    displayName: 'the CSV file',
    uploadCopy: (
      <>
        Either by using our CSV template below, or by using a direct export from your organization’s
        system of record (HRIS, HCM, Active Directory, etc), upload a file including your people
        data that you’d like to import to Sift. The first row in the file should be a header row
        naming each attribute, and each subsequent row should represent a single person.
      </>
    ),
    logo: <CSVLogo data-testid="csv-logo" />,
  },
  [SourceType.AZURE_AD]: {
    type: SourceType.AZURE_AD,
    title: 'Microsoft Azure AD',
    description: `Sift connects to Azure Active Directory via Microsoft Graph to keep data consistently up to date with that in your Microsoft ecosystem. Administrator access to Azure AD is required.`,
    displayName: 'Azure',
    header: 'Authorize Sift to Access Azure AD',
    subtitle: `You will be taken to a Microsoft website to authorize Sift to connect to Azure Active Directory. You will need to be signed into an administrative account that has access to read all Users and Groups in your organization.`,
    logo: <AzureLogo />,
  },
  [SourceType.WORKDAY]: {
    type: SourceType.WORKDAY,
    title: 'Workday',
    description: `Sift connects to Workday via its REST API to keep data consistently up to date. Administrator access to Workday is required.`,
    displayName: 'Workday',
    header: 'Authorize Sift to Workday',
    subtitle: `You will be taken to Workday to authorize Sift to connect. You will need to be signed into an administrative account.`,
    logo: <WorkdayLogo />,
  },
  [SourceType.GOOGLE]: {
    type: SourceType.GOOGLE,
    title: 'Google Workspace',
    description: `Sift connects to Google Workspace to keep data consistently up to date with that in your Google ecosystem. Administrator access to Google Workspace is required.`,
    displayName: 'Google',
    header: 'Authorize Sift to Access Google Workspace',
    subtitle: `By clicking on “Authorize,” you will be taken to Google’s website to authorize Sift to connect with your company’s Google Workspace account. In order to successfully connect, you will need to be an administrator within your Google Workspace account.`,
    logo: <GoogleWorkspaceLogo />,
  },
  [SourceType.DEMO_DATA]: {
    type: SourceType.DEMO_DATA,
    title: 'Use Demo Data',
    description: `Explore Sift features risk-free with Demo Data. Import your own data when you're ready to dive deeper.`,
    displayName: '',
    header: '',
    subtitle: '',
    logo: <DemoDataLogo />,
  },
};

export default sourceData;
